import { AstraAvatar } from '../AstraAvatar/AstraAvatar'
import { AstraDropdownItem } from '../AstraDropdownMenu/AstraDropdownItem'
import { AstraDropdownMenu } from '../AstraDropdownMenu/AstraDropdownMenu'
import { AstraSelect, SelectOption } from '../Inputs/AstraSelect'
import { useSidenavContext } from './AstraSideNavContext'

type Props<T extends number | 'all'> = {
    options: SelectOption<T>[]
    selected?: SelectOption<T>
    onSelect: (value: T) => void
    /** Value to show single-letter avatar when collapsed (defaults to 'all') */
    allValue?: T
}

export function DropdownContent<T extends number | 'all'>({ options, selected, onSelect }: Props<T>) {
    return (
        <>
            {options.filter(Boolean).map(({ label, value }) => (
                <AstraDropdownItem
                    key={label}
                    option={{
                        type: 'action',
                        title: label,
                        action: () => onSelect(value),
                        isActive: selected ? selected.value === value : false,
                    }}
                />
            ))}
        </>
    )
}

export function SidebarDepartmentSelect<T extends number | 'all'>({ options, selected, onSelect, allValue = 'all' as T }: Props<T>) {
    const isOpen = useSidenavContext()
    const initials = selected?.value === allValue ? 'A' : String(selected?.label).at(0)

    return isOpen ? (
        <div data-test="nav-department-selector" className="flex h-8 w-full items-center gap-2 px-1.5">
            <AstraAvatar variant="initial" initials={initials} borderRadius="small" bgOverride="bg-surface-base" />
            <AstraSelect
                className="max-h-8"
                options={options}
                value={selected?.value}
                onChange={value => {
                    if (value) onSelect(value)
                }}
                fullWidth
            />
        </div>
    ) : (
        <div data-test="nav-department-selector" className="flex h-8 items-center justify-center">
            <AstraDropdownMenu
                sideOffset={5}
                placement="right-start"
                dropdownContent={<DropdownContent options={options} selected={selected} onSelect={onSelect} />}
            >
                <button>
                    <AstraAvatar variant="initial" initials={initials} borderRadius="small" bgOverride="bg-surface-base" />
                </button>
            </AstraDropdownMenu>
        </div>
    )
}
